module.exports = __webpack_public_path__ + "media/images/arrow-7e06e7dbfebef028e0fec055b8e80cef.gif";